// This script handles the carousel functionality for the collection grid.
window.addEventListener('load', () => {
  const sections = document.querySelectorAll('.image-collection-grid-section');

  sections.forEach(section => {
    const prevButton = section.querySelector('.image-collection-grid__nav-button--prev');
    const nextButton = section.querySelector('.image-collection-grid__nav-button--next');
    const carousel = section.querySelector('.image-collection-grid__carousel');

    if (!carousel) return;

    // Initially hide the previous button
    prevButton.classList.add('hidden');

    function checkScrollEnd() {
      // Check if the scroll position is at the beginning
      if (carousel.scrollLeft <= 0) {
        prevButton.classList.add('hidden');
      } else {
        prevButton.classList.remove('hidden');
      }

      // Check if the scroll position is at the end
      if (carousel.scrollLeft + carousel.offsetWidth >= carousel.scrollWidth - 1) {
        nextButton.classList.add('hidden');
      } else {
        nextButton.classList.remove('hidden');
      }
    }

    // Add event listeners to the buttons
    prevButton.addEventListener('click', () => {
      const scrollAmount = carousel.offsetWidth;
      carousel.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      // Wait for a moment to check the scroll position after the animation
      setTimeout(checkScrollEnd, 300);
    });

    nextButton.addEventListener('click', () => {
      const scrollAmount = carousel.offsetWidth;
      carousel.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      // Wait for a moment to check the scroll position after the animation
      setTimeout(checkScrollEnd, 300);
    });

    // Check on resize and scroll
    carousel.addEventListener('scroll', checkScrollEnd);
    window.addEventListener('resize', checkScrollEnd);
  });
});
